import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/lobby/$tenantCode/settings')({
  component: LobbyAssetSettingsRedirect,
});

function LobbyAssetSettingsRedirect() {
  const { tenantCode } = Route.useParams();
  return (
    <Navigate
      to="/dashboard/lobby/$tenantCode"
      params={{ tenantCode }}
      search={{ tab: 'asset-settings' }}
      replace
    />
  );
}
